import styled from 'styled-components';
import { QuestionListItem } from 'src/modules/profileSurvey/components/sharedStyles';
type Props = {
  isChecked: boolean;
  title: string;
  type: 'radio' | 'checkbox';
  onChange: (checked: boolean) => void;
};
export default function PollAnswer({
  isChecked,
  type,
  title,
  onChange
}: Props) {
  return <QuestionListItem $isChecked={isChecked} data-sentry-element="QuestionListItem" data-sentry-component="PollAnswer" data-sentry-source-file="pollAnswer.tsx">
      <input checked={isChecked} name="poll" type={type} onChange={e => onChange(e.target.checked)} />
      <Title data-sentry-element="Title" data-sentry-source-file="pollAnswer.tsx">{title}</Title>
    </QuestionListItem>;
}
const Title = styled.span`
  word-wrap: break-word;
`;